module.exports = __webpack_public_path__ + "static/media/bubbles.10fa8b08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameOceanCleanup/bubbles.png
// module id = 2562
// module chunks = 0